import type { TFunction } from "react-i18next"

import {
  CustomFormsSchemaFieldType,
  EmployerOfRecord,
  EmployerOfRecordLiveIndicatorEnum,
  EmployerOfRecordLiveStatusEnum,
  EmployerOfRecordVisaSupportEnum,
} from "@oysterhr/schema"

const liveIndicatorMappedToTranslationKey = {
  [EmployerOfRecordLiveIndicatorEnum.Live]: "Live",
  [EmployerOfRecordLiveIndicatorEnum.LiveConditional]: "LiveConditional",
  [EmployerOfRecordLiveIndicatorEnum.LaunchInProgress]: "LaunchInProgress",
  [EmployerOfRecordLiveIndicatorEnum.NotLive]: "NotLive",
}

const liveStatusMappedToTranslationKey = {
  [EmployerOfRecordLiveStatusEnum.YesExperienced]: "Experienced",
  [EmployerOfRecordLiveStatusEnum.YesExperiencedSubcontractor]: "ExperiencedSubcontractor",
  [EmployerOfRecordLiveStatusEnum.YesNewCountry]: "NewCountryRequest",
  [EmployerOfRecordLiveStatusEnum.YesNewCountrySubcontractor]: "NewCountryRequestSubcontractor",
  [EmployerOfRecordLiveStatusEnum.No]: "No",
  [EmployerOfRecordLiveStatusEnum.LaunchInProgress]: "LaunchInProgress",
}

export const hiringOnboardingTabFields = (
  t: TFunction<"staff_interface/VendorsPage", string>,
  data?: EmployerOfRecord,
) => [
  {
    label: "status",
    type: "jointLiveStatus",
    editModeType: "jointLiveStatus",
    value: [
      {
        label: "liveIndicator",
        translation: data?.details?.liveIndicator
          ? t(
              `detailsPage.liveIndicator.options.${
                liveIndicatorMappedToTranslationKey[data?.details?.liveIndicator]
              }`,
            )
          : "",
        value: data?.details?.liveIndicator,
        type: "liveStatus",
      },
      {
        label: "liveStatus",
        translation: data?.details?.liveStatus
          ? t(
              `detailsPage.liveStatus.options.${
                liveStatusMappedToTranslationKey[data?.details?.liveStatus]
              }`,
            )
          : "",
        value: data?.details?.liveStatus,
      },
      {
        label: "notes",
        value: data?.notes,
      },
    ],
  },
  {
    label: "engagedTeamMembers",
    value: data?.colleaguesEngagedCount,
    editModeType: CustomFormsSchemaFieldType.Text,
    disabled: true,
  },
  {
    label: "visaSupport",
    value: data?.details?.visaSupport,
    editModeType: CustomFormsSchemaFieldType.Dropdown,
    options: Object.values(EmployerOfRecordVisaSupportEnum).map(key => ({
      value: key,
      label: key,
    })),
  },
  {
    label: "visaSupportDetails",
    value: data?.details?.visaSupportDetails,
    editModeType: CustomFormsSchemaFieldType.Text,
  },
  {
    label: "documentsForVisa",
    value: data?.details?.documentsForVisa,
    editModeType: CustomFormsSchemaFieldType.TextArea,
  },
]
